// extracted by mini-css-extract-plugin
export default {"full-height":"CreateControl-module__full-height__2OADY"};